@if (!hideTitleArea) {
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{title}}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modalRef.hide()">
    </button>
  </div>
}
<div class="modal-body">
  <p>{{message}}</p>
</div>

@if (buttons) {
  <div class="modal-footer">
    @for (button of buttons; track button) {
      <button
        type="button"
        class="btn"
        [ngClass]="'btn-' + button.type"
        (click)="close(button.label)">
        {{button.label}}
      </button>
    }
  </div>
}
